import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  loadPage,
  setYear,
  setMonth,
  loadScheduledWorkDiaries,
} from "./workDiariesSlice";
import jsPDF from "jspdf";
import Surface from "../../components/layouts/Surface";
import PeriodSelector from "./components/PeriodSelector";
import UploadTable from "./upload/UploadTable";
import moment from "moment";
import DiariesTable from "./components/DiariesTable";
import { useIntl } from "react-intl";
import { getDiary, loadImage } from "../../components/util/helpers";

const WorkDiaries = (props) => {
  const { nonActive } = props;
  const dispatch = useDispatch();
  const intl = useIntl();
  const [currentDate, setCurrentDate] = useState(moment());
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const organization = useSelector((state) => state.organization.details);
  const { activeYear, activeMonth } = useSelector((state) => state.workDiaries);
  const { scheduledWorkDiariesPage } = useSelector(
    (state) => state.workDiaries
  );
  const diaries = scheduledWorkDiariesPage.items;
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );

  useEffect(() => {
    if (activePatient.id) {
      dispatch(loadPage());
      dispatch(loadScheduledWorkDiaries());
    }
  }, [dispatch, activeYear, activeMonth, activePatient.id]);

  useEffect(() => {
    var month = currentDate ? currentDate.format("M") : null;
    var year = currentDate ? currentDate.format("YYYY") : null;
    dispatch(setMonth({ month: month }));
    dispatch(setYear({ year: year }));
  }, [dispatch, currentDate]);

  const onUploadClick = () => {
    setUploadModalVisible(true);
  };

  const hideUploadModal = () => {
    setUploadModalVisible(false);
  };

  const onNextDate = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
  };

  const onPreviousDate = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
  };

  const onPrinatAll = async () => {
    const avatar_url = organization.avatar_url;
    const logo = await loadImage(avatar_url);
    let diariesPdf = new jsPDF({ orientation: "p" });
    if (diaries && diaries.length > 0) {
      diaries.forEach((item, i) => {
        if (i > 0) {
          diariesPdf.addPage();
          const last = diariesPdf.getNumberOfPages();
          diariesPdf.setPage(last);
        }

        diariesPdf = getDiary(
          diariesPdf,
          intl,
          item,
          organization,
          currentDate,
          logo
        );
      });
      window.open(diariesPdf.output("bloburl"), "_blank");
    }
  };

  const PrintAction = () => (
    <Button
      style={{ margin: "0 10px" }}
      type="text"
      onClick={onPrinatAll}
      size="large"
    >
      {<FormattedMessage id="app.work_diary.prinatAll" />}
    </Button>
  );

  const Actions = () => (
    <div style={{ display: "flex" }}>
      <Button
        style={{ margin: "0 10px" }}
        type="primary"
        onClick={onUploadClick}
        size="large"
        disabled={nonActive}
      >
        {<FormattedMessage id="app.work_diary.upload" />}
      </Button>
      {diaries && diaries.length > 0 && <PrintAction />}
    </div>
  );

  return (
    <div>
      <Surface>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            paddingBottom: "10px",
          }}
        >
          <PeriodSelector
            currentDate={currentDate}
            onNextDate={onNextDate}
            onPreviousDate={onPreviousDate}
          />
          <Actions />
        </div>
        <DiariesTable currentDate={currentDate} diaries={diaries} />
      </Surface>
      <UploadTable
        hideUploadModal={hideUploadModal}
        uploadModalVisible={uploadModalVisible}
      />
    </div>
  );
};

export default WorkDiaries;
